export const navLinks = [
  { label: "首页", href: "#top" },
  { label: "热门短视频", href: "#hot" },
  { label: "福利视频", href: "#welfare" },
  { label: "最新资源", href: "#latest" },
  { label: "专题合集", href: "#collections" },
];

export const heroStats = [
  { value: "12,860+", label: "收录内容" },
  { value: "300+", label: "每日更新" },
  { value: "60+", label: "专题合集" },
];

export const heroPills = [
  "热门短视频",
  "福利视频",
  "最新资源",
  "通勤快刷",
  "睡前放松",
  "美食",
  "旅行",
  "萌宠",
  "音乐",
  "影像",
];

export const collections = [
  {
    id: "c1",
    tag: "通勤快刷",
    title: "地铁到工位，一集刚刚好",
    desc: "单集 3–8 分钟，通勤路上不费脑子，到站正好刷完一段。",
    count: "42 部",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20morning%20city%20commute%20mood%2C%20abstract%20subway%20window%20light%20and%20soft%20motion%20streaks%2C%20warm%20coral%20and%20amber%20gradient%20background%2C%20minimal%20geometric%20shapes%2C%20soft%20film%20grain%20texture%2C%20modern%20magazine%20cover%20aesthetic%2C%20cohesive%20warm%20palette%2C%20high%20detail&width=800&height=500&seq=td-coll-commute&orientation=landscape",
  },
  {
    id: "c2",
    tag: "睡前放松",
    title: "不烧脑、不上头，看着就想睡",
    desc: "轻柔节奏与低起伏叙事，适合关灯后躺着慢慢看完。",
    count: "36 部",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20calm%20bedtime%20night%20mood%2C%20abstract%20moon%20and%20floating%20stars%20over%20soft%20hills%2C%20warm%20amber%20and%20deep%20rose%20gradient%20background%2C%20minimal%20geometric%20shapes%2C%20soft%20film%20grain%20texture%2C%20modern%20magazine%20cover%20aesthetic%2C%20cohesive%20warm%20palette%2C%20high%20detail&width=800&height=500&seq=td-coll-night&orientation=landscape",
  },
  {
    id: "c3",
    tag: "周末片单",
    title: "周六窝在沙发，一次性刷完",
    desc: "把一周攒下的长内容打包，配好零食就能连着看。",
    count: "58 部",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20lazy%20weekend%20leisure%20mood%2C%20abstract%20sofa%2C%20picnic%20blanket%20and%20screen%20shapes%2C%20warm%20coral%20amber%20gradient%20background%2C%20minimal%20geometric%20shapes%2C%20soft%20film%20grain%20texture%2C%20modern%20magazine%20cover%20aesthetic%2C%20cohesive%20warm%20palette%2C%20high%20detail&width=800&height=500&seq=td-coll-weekend&orientation=landscape",
  },
  {
    id: "c4",
    tag: "新手必看",
    title: "第一次来糖豆，从这几部开始",
    desc: "按兴趣分好的入门清单，先看这几部就能摸清门道。",
    count: "24 部",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20beginner%20guide%20mood%2C%20abstract%20compass%2C%20star%20and%20folded%20map%20shapes%2C%20warm%20coral%20amber%20gradient%20background%2C%20minimal%20geometric%20shapes%2C%20soft%20film%20grain%20texture%2C%20modern%20magazine%20cover%20aesthetic%2C%20cohesive%20warm%20palette%2C%20high%20detail&width=800&height=500&seq=td-coll-starter&orientation=landscape",
  },
];

export const hotVideos = [
  {
    id: "h1",
    title: "老街清晨的第一锅豆浆",
    category: "城市美食",
    duration: "02:14",
    views: "128.6 万",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20quiet%20old%20street%20breakfast%20stall%20at%20dawn%2C%20steaming%20bowl%20and%20warm%20lantern%20light%2C%20warm%20coral%20amber%20gradient%20background%2C%20minimal%20geometric%20shapes%2C%20soft%20film%20grain%20texture%2C%20modern%20magazine%20cover%20aesthetic%2C%20cohesive%20warm%20palette%2C%20high%20detail&width=640&height=400&seq=td-vid-soymilk&orientation=landscape",
  },
  {
    id: "h2",
    title: "30 秒看懂视频调色",
    category: "影像技巧",
    duration: "01:38",
    views: "96.2 万",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20video%20color%20grading%20mood%2C%20abstract%20color%20wheels%20and%20gradient%20bars%2C%20warm%20coral%20amber%20gradient%20background%2C%20minimal%20geometric%20shapes%2C%20soft%20film%20grain%20texture%2C%20modern%20magazine%20cover%20aesthetic%2C%20cohesive%20warm%20palette%2C%20high%20detail&width=640&height=400&seq=td-vid-color&orientation=landscape",
  },
  {
    id: "h3",
    title: "山脊线上的日落云海",
    category: "旅行风光",
    duration: "03:05",
    views: "210.4 万",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20mountain%20ridge%20sunset%20over%20a%20sea%20of%20clouds%2C%20abstract%20layered%20peaks%20and%20glowing%20sun%2C%20warm%20coral%20amber%20gradient%20background%2C%20minimal%20geometric%20shapes%2C%20soft%20film%20grain%20texture%2C%20modern%20magazine%20cover%20aesthetic%2C%20cohesive%20warm%20palette%2C%20high%20detail&width=640&height=400&seq=td-vid-sunset&orientation=landscape",
  },
  {
    id: "h4",
    title: "手作陶杯从拉坯到出窑",
    category: "纪录手工",
    duration: "04:42",
    views: "74.9 万",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20handmade%20pottery%20crafting%20mood%2C%20abstract%20clay%20vessel%20on%20a%20spinning%20wheel%2C%20warm%20coral%20amber%20gradient%20background%2C%20minimal%20geometric%20shapes%2C%20soft%20film%20grain%20texture%2C%20modern%20magazine%20cover%20aesthetic%2C%20cohesive%20warm%20palette%2C%20high%20detail&width=640&height=400&seq=td-vid-pottery&orientation=landscape",
  },
  {
    id: "h5",
    title: "橘猫第一次见到雪",
    category: "萌宠日常",
    duration: "00:52",
    views: "305.1 万",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20playful%20orange%20cat%20meeting%20snow%20for%20the%20first%20time%2C%20abstract%20soft%20snowflakes%20and%20paw%20prints%2C%20warm%20coral%20amber%20gradient%20background%2C%20minimal%20geometric%20shapes%2C%20soft%20film%20grain%20texture%2C%20modern%20magazine%20cover%20aesthetic%2C%20cohesive%20warm%20palette%2C%20high%20detail&width=640&height=400&seq=td-vid-cat&orientation=landscape",
  },
  {
    id: "h6",
    title: "天台上的不插电现场",
    category: "音乐现场",
    duration: "05:18",
    views: "143.7 万",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20an%20intimate%20rooftop%20acoustic%20live%20set%2C%20abstract%20guitar%20and%20warm%20string%20lights%2C%20warm%20coral%20amber%20gradient%20background%2C%20minimal%20geometric%20shapes%2C%20soft%20film%20grain%20texture%2C%20modern%20magazine%20cover%20aesthetic%2C%20cohesive%20warm%20palette%2C%20high%20detail&width=640&height=400&seq=td-vid-acoustic&orientation=landscape",
  },
];

export const welfareItems = [
  {
    id: "w1",
    badge: "本周主推",
    title: "福利片单 · 高清修复专场",
    desc: "经典老片逐帧修复，画质与色彩一并还原，活动期间全部开放畅看。",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20classic%20film%20restoration%20mood%2C%20abstract%20vintage%20film%20reels%20and%20glowing%20frames%2C%20warm%20coral%20amber%20gradient%20background%2C%20minimal%20geometric%20shapes%2C%20soft%20film%20grain%20texture%2C%20modern%20magazine%20cover%20aesthetic%2C%20cohesive%20warm%20palette%2C%20high%20detail&width=700&height=440&seq=td-welfare-restore&orientation=landscape",
  },
  {
    id: "w2",
    badge: "新人专享",
    title: "新用户见面礼包",
    desc: "注册即领无广告畅看体验，热门短视频与最新资源同步解锁。",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20welcome%20gift%20box%20opening%20with%20sparkles%2C%20abstract%20ribbon%20and%20confetti%20shapes%2C%20warm%20coral%20amber%20gradient%20background%2C%20minimal%20geometric%20shapes%2C%20soft%20film%20grain%20texture%2C%20modern%20magazine%20cover%20aesthetic%2C%20cohesive%20warm%20palette%2C%20high%20detail&width=700&height=440&seq=td-welfare-gift&orientation=landscape",
  },
  {
    id: "w3",
    badge: "每日限定",
    title: "深夜限定合辑",
    desc: "每天 22:00 更新一支隐藏片源，隔天替换，错过就要再等一周。",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20late%20night%20exclusive%20mood%2C%20abstract%20moonlit%20window%20and%20neon%20glow%20without%20blue%2C%20warm%20coral%20amber%20gradient%20background%2C%20minimal%20geometric%20shapes%2C%20soft%20film%20grain%20texture%2C%20modern%20magazine%20cover%20aesthetic%2C%20cohesive%20warm%20palette%2C%20high%20detail&width=700&height=440&seq=td-welfare-late&orientation=landscape",
  },
];

export const latestResources = [
  {
    id: "l1",
    title: "《城市凌晨四点》第三集上线",
    summary: "跟着夜班司机穿过整座城，记录打烊后的街灯、便利店与早餐摊。",
    category: "纪实",
    time: "今天 09:20",
  },
  {
    id: "l2",
    title: "夏日冰饮 12 种做法合集",
    summary: "从话梅气泡到杨枝甘露，一条视频教会你在家复刻，配比写得很清楚。",
    category: "美食",
    time: "今天 08:05",
  },
  {
    id: "l3",
    title: "老港片修复专区更新",
    summary: "新增 18 部 4K 修复片源，胶片颗粒与颜色一并保留，细节更耐看。",
    category: "福利",
    time: "昨天 21:40",
  },
  {
    id: "l4",
    title: "手机剪辑 30 天上手计划",
    summary: "收纳、卡点、转场到调色，按天拆成可以照着做的小练习。",
    category: "影像",
    time: "昨天 18:12",
  },
  {
    id: "l5",
    title: "山野露营装备避坑指南",
    summary: "新手最常踩的 6 个坑，附一份从帐篷到照明灯具的采购清单。",
    category: "旅行",
    time: "昨天 15:30",
  },
  {
    id: "l6",
    title: "周末音乐现场精选",
    summary: "收录 9 支独立乐队的现场实录，带完整曲目时间轴，方便跳着看。",
    category: "音乐",
    time: "前天 20:00",
  },
  {
    id: "l7",
    title: "萌宠行为小课堂",
    summary: "从摇尾巴到踩奶，一次读懂毛孩子每天都在用动作表达什么。",
    category: "萌宠",
    time: "前天 11:15",
  },
  {
    id: "l8",
    title: "一周高分短片榜",
    summary: "综合播放量与完播率，挑出本周值得回看的 10 部短片。",
    category: "榜单",
    time: "前天 09:00",
  },
];

export const trustPoints = [
  {
    icon: "ri-layout-masonry-line",
    title: "分类清晰",
    desc: "短视频、福利视频、最新资源分栏陈列，找片不用层层翻找。",
  },
  {
    icon: "ri-refresh-line",
    title: "更新及时",
    desc: "每日多时段补充片源，新内容上线即进入最新资源列表。",
  },
  {
    icon: "ri-speed-up-line",
    title: "高清流畅",
    desc: "自适应码率播放，弱网环境也尽量保持画面不卡顿。",
  },
  {
    icon: "ri-gift-2-line",
    title: "免费畅看",
    desc: "基础内容无需付费，打开即看，不设繁琐的观看门槛。",
  },
];

export const faqs = [
  {
    id: "f1",
    q: "糖豆视频可以免费观看吗？",
    a: "基础短视频与最新资源均可免费观看；福利专区偶尔会有活动专属内容，站内都会提前标注，方便你按需选择。",
  },
  {
    id: "f2",
    q: "找不到想看的分类怎么办？",
    a: "首页已按热门短视频、福利视频、最新资源分区，可在顶部搜索框输入关键词，或直接从专题合集入手浏览。",
  },
  {
    id: "f3",
    q: "内容大概多久更新一次？",
    a: "每日多时段更新，最新资源列表按时间倒序排列，当天新增的片源会优先排在最前面。",
  },
  {
    id: "f4",
    q: "播放卡顿应该怎么处理？",
    a: "建议先切换清晰度档位或更换网络，播放器会自动适配码率；若仍然异常，稍后重新进入一般即可恢复。",
  },
  {
    id: "f5",
    q: "手机上也能正常观看吗？",
    a: "支持桌面端与移动端浏览，页面会自动适配屏幕，列表与封面同样排版清晰，滑动即可连续观看。",
  },
];

export const footerColumns = [
  {
    title: "内容分区",
    links: ["热门短视频", "福利视频", "最新资源", "专题合集"],
  },
  {
    title: "关于我们",
    links: ["平台介绍", "更新说明", "内容规范", "反馈建议"],
  },
  {
    title: "帮助中心",
    links: ["观看指南", "常见问题", "播放排障", "意见反馈"],
  },
];